<template>
  <div>
    <div class="row ml-2 pt-3">
                  

      <div class="col-10">
        <h4 class="text-heading text-left" v-if="isParent">Order Summary</h4>
        <h4 class="text-heading text-left" v-if="!isParent">Branch Order Summary</h4>
      </div>
      <div class="col-2 text-left">
        <p class="m-1 p-0 back-div-text-style" v-if="!isParent" @click="showParentOrderSummary()">
          <img class="right-arrow left-arrow-to-parent mb-0" src="@/assets/images/right-arrow.svg" />&nbsp;
          <span class="back-to-parent">Back to Parent</span>
        </p>
      </div>
    </div>
    <!-- <w-dropDown
      :options="partnerTypes"
      @dropdownChange="getselectedPartnerType($event)"
      validation="required"
      :selected="selectedPartnerType"
      class="mb-1 mt-2"
    />-->
    <div class="m-0 p-0 mx-5 mt-2">
      <div class="row">
        <w-dropDown
          :options="partnerTypes"
          @dropdownChange="getselectedPartnerType($event)"
          validation="required"
          :selected="selectedPartnerType"
          class="ml-3 col-2 text-right"
          :labelName="'Partner Type'"
        />
        <div class="ml-4 col-3">
          <v-text-field
            v-model="partnerDetailsFilterText"
            @keydown="clickedSearch"
            @keyup="clickedSearch"
            label="Search job number"
            clearable
          ></v-text-field>
        </div>
      </div>
      <div class="row">
        <div class="position-relative ml-3 mr-5" v-if="isParent">
          <div
            class="p-1 mt-2 text-left filter-duration cursor-pointer"
            @click="selectFilterDuration()"
          >
            <img class="mr-1" src="@/assets/Icons/calenderIcon.svg" />
            <span class="p-0 m-0 mt-2 ml-1 duration-filed">{{selectedFilterText}}</span>
            <img
              v-if="selectedFilterText != 'Select Duration'"
              class="removefilter-icon"
              src="@/assets/images/close1.svg"
              @click="removeFilterDuration()"
            />
          </div>
          <w-button-input
            :popoverShow="selectedDateDuration"
            @selectedFilterCategory="getSelectedFilter($event)"
            :selected="partnerOrderSelectedValue"
            :radios="partnerOrderSelectedRadiosValue"
            :companycode="companycode"
            :categoryCode="categoryCode"
            :financialYear="financialYear"
            :sourceFrom="'summary'"
          />
        </div>
        <div class="mt-2 col-3 p-0 m-0">
          <w-multi-select-dropdown
            :ref="'multiselectRef'"
            :labelText="'Categories'"
            :labelClass="'label-class'"
            :position="'bottom'"
            :sourceFrom="'partnersummary'"
            :optionFields="categoryFilterOption"
            @selectedMultiselectEvent="getMultiSelectedDropdown($event,i)"
            :defaultValue="bindSelectedDropdown(selectedCategoryFilter)"
          />
          <img
            v-if="selectedCategoryFilter.length > 0"
            class="removefilter-icon-drop mr-1"
            src="@/assets/images/close1.svg"
            @click="removeCategoryFilter()"
          />
        </div>
        <div class="pagination-potable-table mt-2 mr-5" @click="getSummaryCurrentPage()">
          <b-pagination
            v-model="summaryPaginationCurrentPage"
            :total-rows="woPaginationTotalRow"
            :per-page="summaryPaginationPerPage"
            aria-controls="my-table"
          ></b-pagination>
        </div>
      </div>
      <div class="card-background">
        <w-collapse-table
          :tableProperties="poTableDataList"
          :tableLoading="showTableLoding"
          :filter="partnerDetailsFilterText"
          @getPoNumber="goToPoWoDetails($event,currency)"
          :typeOfTable="'summaryTable'"
          :jobtype="selectedCategory"
        />
      </div>
    </div>
    <v-dialog
      v-model="dialog"
      :scrollable="true"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <div class="po-toolbar">
          <p class="toolbar-heading mt-2 ml-3">
            {{selectedCategory}} Information of {{currentPOnumber}}
            <img
              align="right"
              class="mr-4 mt-2 close-icon mb-2"
              src="@/assets/close.svg"
              @click="dialog = false"
            />
          </p>
        </div>
        <!-- <b-card class="card m-4">
          <div class="row p-0 m-0">
            <div class="col p-0 m-0">
              <p class="text-left mr-3">Job</p>
              <p class="text-left">{{jobDetails.job}}</p>
        </div>-->
        <!-- <span class="text-left mr-3">Job DEs</span>
        <span class="text-left">{{jobDetails.job}}</span>-->
        <!-- </div> -->
        <div class="text-left p-0 m-0">
          <br />
          <span class="ml-4 mr-2 terms-heading">Job</span>:
          <span class="terms-heading-value">{{jobDetails.job}}</span>
          <span class="ml-4 mr-2 terms-heading">Job Description</span>:
          <span class="terms-heading-value">{{jobDetails.jobDesc}}</span>
          <span
            class="ml-4 mr-2 terms-heading"
          >{{selectedCategory}} Value({{poInvoiceCurrencyType}})</span>:
          <span
            class="cursor-pointer"
            v-if="jobDetails.poCurrencyValue"
            v-b-tooltip.hover.top="`[${jobDetails.poCurrencyDesc}] ${jobDetails.poCurrencyValue}`"
          >{{jobDetails.poValue}}</span>
          <span class="curosr-pointer terms-heading-value" v-else>{{jobDetails.poValue}}</span>
          <span class="ml-4 mr-2 terms-heading">{{selectedCategory}} Type</span>:
          <span class="terms-heading-value">{{jobDetails.poType}}</span>
          <span class="mr-4 m-0 p-0 information-amount-text">All values are in {{jobCurrency}}</span>
        </div>

        <!-- </b-card> -->
        <b-card class="card m-4">
          <h3 class="card-heading mb-3">{{selectedCategory}} Details</h3>
          <v-expansion-panel v-if="category.length > 0" v-model="keyCustomerPanel">
            <v-expansion-panel-content
              expand-icon="mdi-menu-down"
              v-for="(item,i) in jobDetails.category"
              :key="i"
            >
              <template v-slot:header>
                <div v-if="keyCustomerPanel==i">
                  <img class="mr-4" src="../../assets/images/downArrow.svg" />
                  {{item.categoryResponse}}
                </div>
                <div v-else>
                  <img class="mr-4" src="../../assets/images/upArrow.svg" />
                  {{item.categoryResponse}}
                </div>
              </template>
              <v-card class="card-background">
                <b-table
                  sticky-header="200px"
                  class="exapansion-table m-2"
                  :items="item.materialDetails"
                  :fields="topOrderData.fields"
                  head-variant="#6192b1"
                  responsive="sm"
                  striped
                  style="max-height:265px; overflow:auto;"
                >
                  <template v-slot:cell(materialCode)="row">
                    <span v-if="row.item.importType == 'Y'">
                      <button
                        :id="`popoverRemarks${row.index}`"
                        style="cursor:pointer"
                      >{{row.item.materialCode}}</button>
                    </span>
                    <span v-else>{{row.item.materialCode}}</span>
                    <b-popover
                      v-if="row.item.importType == 'Y'"
                      :target="`popoverRemarks${row.index}`"
                      triggers="hover"
                      placement="bottom-right"
                      class="m-2"
                    >
                      <div>
                        <table class="table">
                          <thead>
                            <tr class="table-bg">
                              <th class="table-body-name" scope="col">Landed Value</th>
                              <th class="table-body-name" scope="col">CIF</th>
                              <th class="table-body-center" scope="col">CD</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="color-bg">
                              <td class="table-body-name">{{row.item.landedValue}}</td>
                              <td class="table-body-name">{{row.item.cif}}</td>
                              <td class="table-body-center">{{row.item.customsDuty}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-popover>
                  </template>
                  <template slot="rate" slot-scope="row">
                    <span class="table-number ml-3">{{amountSeprater(row.item.rate)}}</span>
                  </template>
                  <template v-slot:cell(poHandleValue)="row">
                    <span
                      style="cursor:pointer"
                      v-if="row.item.nativeCurrencyValue"
                      v-b-tooltip.hover.left="`[${row.item.nativeCurrencyDesc}] ${row.item.nativeCurrencyValue}`"
                    >{{row.item.poHandleValue}}</span>
                    <span v-else>{{row.item.poHandleValue}}</span>
                  </template>
                </b-table>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <h4 v-else class="error-text">No Record Available</h4>
        </b-card>
        <b-card class="card m-4">
          <h3 class="card-heading">Terms & Conditions</h3>
          <div class="row m-0 p-0">
            <div class="col-6 m-0 p-0">
              <div class="row m-0 p-0">
                <div class="col m-0 p-0 terms-heading">Bank Guarantee</div>
                <h5>:</h5>
                <div
                  class="col m-0 p-0 terms-text"
                  v-if="termsAndConditions.bankGaurentee"
                >{{termsAndConditions.bankGaurentee}}</div>
                <div class="col m-0 p-0 terms-text" v-else>-</div>
              </div>
            </div>
            <div class="col-3 m-0 p-0">
              <div class="row">
                <div class="col m-0 p-0 terms-heading">DLP</div>
                <h5>:</h5>
                <div
                  class="col m-0 p-0 terms-text"
                  v-if="termsAndConditions.dlp"
                >{{termsAndConditions.dlp}}</div>
                <div class="col m-0 p-0 terms-text" v-else>-</div>
              </div>
            </div>
            <div class="col-3 m-0 p-0">
              <div class="row">
                <div class="col m-0 p-0 terms-heading">Delivery</div>
                <h5>:</h5>
                <div
                  class="col m-0 p-0 terms-text"
                  v-if="termsAndConditions.delivery"
                >{{termsAndConditions.delivery}}</div>
                <div class="col m-0 p-0 terms-text" v-else>-</div>
              </div>
            </div>
          </div>
          <div class="row m-0 p-0">
            <div class="col-6 m-0 p-0">
              <div class="row">
                <div class="col m-0 p-0 terms-heading">Price Variation</div>
                <h5>:</h5>
                <div
                  class="col m-0 p-0 terms-text"
                  v-if="termsAndConditions.priceVariation"
                >{{termsAndConditions.priceVariation}}</div>
                <div class="col m-0 p-0 terms-text" v-else>-</div>
              </div>
            </div>
            <div class="col-3 m-0 p-0">
              <div class="row">
                <div class="col m-0 p-0 terms-heading">LD</div>
                <h5>:</h5>
                <div
                  class="col m-0 p-0 terms-text"
                  v-if="termsAndConditions.ld"
                >{{termsAndConditions.ld}}</div>
                <div class="col m-0 p-0 terms-text" v-else>-</div>
              </div>
            </div>
          </div>
          <div class="row m-0 p-0 pr-2">
            <div class="col-12 m-0 p-0">
              <div class="row m-0 p-0">
                <div class="col-3 ml-n2 m-0 p-0 terms-heading">Payment terms</div>
                <h5>:</h5>
                <div
                  class="col m-0 p-0 terms-text"
                  v-if="termsAndConditions.paymentTerms && selectedCategory == 'PO'"
                >{{termsAndConditions.paymentTerms}}</div>
                <div
                  class="col m-0 p-0 terms-text"
                  v-if="!termsAndConditions.paymentTerms && selectedCategory == 'PO'"
                >-</div>
                <div
                  class="col m-0 p-0 terms-text"
                  v-if="termsAndConditions.paymentTerms && selectedCategory == 'WO'"
                >
                  <span>
                    <ol>
                      <li v-for="(data,i) in termsAndConditions.paymentTerms" :key="i">{{data}}</li>
                    </ol>
                  </span>
                </div>
                <div
                  class="col m-0 p-0"
                  v-if="!termsAndConditions.paymentTerms && selectedtabs == 'Wo'"
                >-</div>
              </div>
            </div>
          </div>
        </b-card>
        <b-card class="card m-4">
          <h3 class="card-heading">Invoice Summary</h3>
          <div class="row">
            <div class="col">
              <p class="p-0 m-0 pr-5 mr-5 jobText">Number of Invoices</p>
              <p
                class="p-0 m-0 pr-5 mr-5 jobNum"
                v-if="invoiceSummary.numberOfInvoice"
              >{{invoiceSummary.numberOfInvoice}}</p>
              <p class="p-0 m-0 pr-5 mr-5 jobNum" v-else>-</p>
            </div>
            <div class="col">
              <p class="p-0 m-0 pr-5 mr-5 jobText">Invoice Raised ({{poInvoiceCurrencyType}})</p>
              <p
                class="p-0 m-0 pr-5 mr-5 jobNum"
                v-if="invoiceSummary.invoiceRaised"
              >{{invoiceSummary.invoiceRaised}}</p>
              <p class="p-0 m-0 pr-5 mr-5 jobNum" v-else>-</p>
            </div>
            <div class="col">
              <p class="p-0 m-0 pr-5 mr-5 jobText">Amount paid ({{poInvoiceCurrencyType}})</p>
              <p
                class="p-0 m-0 pr-5 mr-5 jobNum"
                v-if="invoiceSummary.amountPaid"
              >{{invoiceSummary.amountPaid}}</p>
              <p class="p-0 m-0 pr-5 mr-5 jobNum" v-else>-</p>
            </div>
          </div>
          <div v-if="invoiceTable.items.length > 0" class="card-background">
            <b-table
              sticky-header="200px"
              class="exapansion-table m-2"
              :items="invoiceTable.items"
              :fields="invoiceTable.fields"
              head-variant="#6192b1"
              responsive="sm"
              striped
              style="max-height:265px; overflow:auto;"
              :busy="tableLoading"
              show-empty
              empty-text="No Records Found"
            >
              <template slot="invoiceValue" slot-scope="row">
                <span class="table-number ml-3">{{amountSeprater(row.item.invoiceValue)}}</span>
              </template>
            </b-table>
          </div>
          <div
            v-if="invoiceTable.items.length > 0"
            class="pagination-invoice-table ml-auto"
            @click="getCurrentPage()"
          >
            <!-- <b-pagination
              v-model="summaryPaginationCurrentPage"
              :total-rows="woPaginationTotalRow"
              :per-page="summaryPaginationPerPage"
              aria-controls="my-table"
            ></b-pagination>-->
            <b-pagination
              v-model="invoicePaginationCurrentPage"
              :total-rows="paginationTotalRow"
              :per-page="invoicePaginationPerPage"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </b-card>
      </v-card>
    </v-dialog>
    <!-- <b-modal size="xl" title="Extra Large Modal">
      <h3 class="card-heading">PO Details</h3>
    </b-modal>-->
    <w-loadingSpinner :loadSpinner="loading" />
  </div>
</template>


<script>
import LoadingSpinner from "../../widgets/LoadingSpinner";
import { PartnerService } from "../../services/partnerService";
import widgetModal from "../../widgets/newModalWidget";
import partnertable from "../../widgets/partner-table-collapsable";
import dynamicdropdown from "../../widgets/dropdownpartner";
import ButtonFilterVue from "../../widgets/filterselection.vue";
const partnerService = new PartnerService();
import { CommonService } from "../../services/CommonService";
import { AESService } from "../../services/AES.js";
const commonService = new CommonService();
import multiSelect from "../../widgets/multiSelect";


export default {
  components: {
    "w-collapse-table": partnertable,
    "w-dropDown": dynamicdropdown,
    "w-loadingSpinner": LoadingSpinner,
    "w-button-input": ButtonFilterVue,
    "w-multi-select-dropdown": multiSelect
  },
  created() {
    if (this.$route.params.partnerId && this.$route.params.partnerJobType) {
      this.branchRedirectedPartnerId = this.$route.params.partnerId;
      let partnerType = this.$route.params.partnerJobType;
      if (partnerType == "Supplier") {
        this.branchPartnerJobType = "po";
      } else if (partnerType == "Service Provider") {
        this.branchPartnerJobType = "wo";
      }
      this.selectedWorkCategory = this.branchPartnerJobType;
      this.selectedCategory = this.branchPartnerJobType.toUpperCase();
      this.poTableDataList.items = [];
      this.loading = true;
      this.isParent = false;
      this.partnerTypes.push({
        text: this.$route.params.partnerJobType,
        value: this.selectedCategory
      });
      this.selectedPartnerType = this.selectedCategory;
      var data = {
        category: [],
        jobType: this.branchPartnerJobType,
        partnerId: this.branchRedirectedPartnerId,
        from: null,
        to: null
      };
      partnerService
        .getJobDetails(
          data,
          this.summaryPaginationPerPage,
          this.summaryCurrentPage - 1
        )
        .then(resp => {
          this.showTableLoding = false;
          this.poTableDataList.items = resp.response.content;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      this.getpartnerDetails();
      // this.slectedPartnerType();
    }
  },
  watch: {},
  data() {
    return {
      dialog: false,
      showTableLoding: false,
      category: [],
      financialYear: [],
      tempFinancialYear: [],
      termsAndConditions: "",
      partnerDetailsFilterText: "",
      invoiceSummary: "",
      companycode: "",
      paginationTotalRow: 5,
      invoicePaginationPerPage: 5,
      invoicePaginationCurrentPage: 1,
      woPaginationTotalRow: 10,
      summaryPaginationPerPage: 10,
      summaryPaginationCurrentPage: 1,
      summaryCurrentPage: 1,
      tempCurrentPage: 1,
      currentPOnumber: "",
      selectedWorkCategory: "",
      loading: false,
      jobCurrency: "",
      selectedCategory: "",
      selectedDateDuration: false,
      partnerId: null,
      jobDetails: [],
      categoryFilterOption: [],
      selectedCategoryFilter: [],
      partnerTypes: [{ value: null, text: "Select Period", disabled: true }],
      defaultFilter: {
        text: "All",
        value: 1
      },
      poTableDataList: {
        fields: [
          {
            key: "jobCode",
            label: "Job Number",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "jobDesc",
            label: "Job Description",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "noOfPOs",
            label: "No of Orders",
            thClass: "table-heading-text",
            tdClass: "text-right"
          },
          {
            key: "cost",
            label: "Value ()",
            thClass: "table-heading-text",
            tdClass: "text-right"
          },
          // {
          //   key: "quality",
          //   label: "Quality",
          //   thClass: "thClassLeft",
          //   tdClass: "text-left"
          // },
          // {
          //   key: "safety",
          //   label: "Safety",
          //   thClass: "thClassLeft",
          //   tdClass: "text-left"
          // },
          // {
          //   key: "risk",
          //   label: "Risk",
          //   thClass: "thClassLeft",
          //   tdClass: "text-left"
          // },
          // {
          //   key: "completion",
          //   label: "Completion",
          //   thClass: "thClassLeft",
          //   tdClass: "text-left"
          // },
          // {
          //   key: "ahead",
          //   label: "Ahead",
          //   thClass: "thClassLeft",
          //   tdClass: "text-left"
          // },
          // {
          //   key: "ragStatus",
          //   label: "Rag Status",
          //   thClass: "thClassCenter",
          //   tdClass: "text-center"
          // },
          {
            key: "toggle_icon",
            label: "",
            thClass: "thClassCenter",
            tdClass: "text-center"
          }
        ],
        items: []
      },
      invoiceTable: {
        fields: [],
        items: []
      },
      topOrderData: {
        fields: [],
        items: []
      },
      branchRedirectedPartnerId: "",
      branchPartnerJobType: "",
      poInvoiceCurrencyType: "",
      isParent: true
    };
  },
  methods: {
    amountSeprater(value) {
      var x = value;
      x = value.toString();
      var afterPoint = "";
      if (x.indexOf(".") > 0)
        afterPoint = x.substring(x.indexOf("."), x.length);
      x = Math.floor(x);
      x = x.toString();
      var lastThree = x.substring(x.length - 3);
      var otherNumbers = x.substring(0, x.length - 3);
      if (otherNumbers != "") lastThree = "," + lastThree;
      var res =
        otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
        lastThree +
        afterPoint;
      return res;
    },
    selectFilterDuration() {
      this.selectedDateDuration = !this.selectedDateDuration;
    },
    removeFilterDuration() {
      this.getSelectedFilter(this.defaultFilter);
      this.selectedDateDuration = !this.selectedDateDuration;
    },
    removeCategoryFilter() {
      this.selectedCategoryFilter = [];
      this.getJobDetail();
    },
    getselectedPartnerType(event) {
      console.log(event);
      this.selectedPartnerType = event;
      if (this.selectedPartnerType == 2) {
        this.selectedWorkCategory = "po";
        this.selectedCategory = "PO";
        this.getJobDetail();
      } else {
        this.selectedWorkCategory = "wo";
        this.selectedCategory = "WO";
        console.log(this.selectedWorkCategory);
        this.getJobDetail();
      }
    },
    getpartnerDetails() {
      partnerService.getPartnerInfo().then(resp => {
        this.companycode = resp.response.currentCompanyCode;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
        this.partnerId = resp.response.partnerId;
        this.loading = false;
        this.slectedPartnerType();
      });
    },
    slectedPartnerType() {
      this.poTableDataList.items = [];
      partnerService.getPartnertype(this.companycode).then(resp => {
        if (resp.response) {
          resp.response.forEach((item, index) => {
            if (item.status == "A") {
              this.partnerTypes.push({
                text: item.description,
                value: item.partnerTypeCode
              });
            }
          });

          console.log(this.selectedPartnerType);

          // SELECTED FROM PARTNER DASHBOARD
          if (
            this.$route.params &&
            (this.$route.params.selctedBussinessType ||
              this.$route.params.selectedCategory)
          ) {
            if (this.$route.params.selectedCategory) {
              this.selectedCategoryFilter = [];
              this.selectedCategoryFilter.push(
                this.$route.params.selectedCategory
              );
            }
            var partnerTypeFromReminder = this.$route.params
              .selctedBussinessType;
            this.partnerTypes.forEach((item, index) => {
              if (item.value == partnerTypeFromReminder) {
                this.selectedPartnerType = item.value;
                this.categoryCode = item.value;
              }
            });
            if (this.selectedPartnerType == 2) {
              this.selectedWorkCategory = "po";
              this.selectedCategory = "PO";
              this.getSelectedFilter(this.defaultFilter);
              this.getFinancialYear("2");
            } else if (this.selectedPartnerType == 3) {
              this.selectedWorkCategory = "wo";
              this.selectedCategory = "WO";
              this.getSelectedFilter(this.defaultFilter);
              this.getFinancialYear("3");
            }
            this.loading = false;

            this.partnerCategoryFilter();
          } else {
            // SELECTED WHILE PAGE LOAD

            this.loading = false;
            console.log(this.partnerTypes);
            this.selectedPartnerType = this.partnerTypes[1].value;
            this.categoryCode = this.selectedPartnerType;
            if (this.selectedPartnerType == 2) {
              this.selectedWorkCategory = "po";
              this.selectedCategory = "PO";
              this.getSelectedFilter(this.defaultFilter);
              this.getFinancialYear("2");
            } else {
              this.selectedWorkCategory = "wo";
              this.selectedCategory = "WO";
              this.getSelectedFilter(this.defaultFilter);
              this.getFinancialYear("3");
            }
            this.partnerCategoryFilter();
          }
        }
      });
    },

    openpopup() {
      this.dialog = true;
    },
    closepop() {
      this.dialog = false;
    },
    getFinancialYear(categoryCode) {
      this.financialYear = [];
      commonService
        .getFinancialYears(this.companycode, categoryCode)
        .then(res => {
          if (res.failureMessage == "") {
            res.response.forEach((element, i) => {
              let tempYear = {
                value: i + 6,
                text: element.financialYear
              };
              this.financialYear.push(tempYear);
              this.tempFinancialYear.push(element);
            });
          } else {
            this.financialYear = [];
          }
        });
    },
    getSelectedFilter(event) {
      console.log(event);
      let topOrderEndDate = "";
      let topOrderStartDate = "";
      this.selectedFilterText = event.text;
      if (event.value > 4) {
        this.partnerOrderSelectedValue = 5;
        this.partnerOrderSelectedRadiosValue = event.value;
      } else {
        this.partnerOrderSelectedValue = event.value;
        this.partnerOrderSelectedRadiosValue = 6;
      }
      this.selectedDateDuration = false;
      var currentDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      );
      if (event.value == 1) {
        topOrderEndDate = "";
        topOrderStartDate = "";
        this.getJobDetail(topOrderStartDate, topOrderEndDate);
      } else if (event.value == 2) {
        var oneMonthAgo = new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          new Date().getDate()
        );
        topOrderEndDate = currentDate.toLocaleDateString();
        topOrderStartDate = oneMonthAgo.toLocaleDateString();
        this.getJobDetail(topOrderStartDate, topOrderEndDate);
      } else if (event.value == 3) {
        var threeMonthAgo = new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 3,
          new Date().getDate()
        );
        topOrderEndDate = currentDate.toLocaleDateString();
        topOrderStartDate = threeMonthAgo.toLocaleDateString();
        this.getJobDetail(topOrderStartDate, topOrderEndDate);
      } else if (event.value == 4) {
        var sixMonthAgo = new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 6,
          new Date().getDate()
        );
        topOrderEndDate = currentDate.toLocaleDateString();
        topOrderStartDate = sixMonthAgo.toLocaleDateString();
        this.getJobDetail(topOrderStartDate, topOrderEndDate);
      } else if (event.value > 4) {
        for (let j = 0; j < this.tempFinancialYear.length; j++) {
          if (event.text == this.tempFinancialYear[j].financialYear) {
            topOrderEndDate = this.tempFinancialYear[j].to;
            topOrderStartDate = this.tempFinancialYear[j].from;
            break;
          }
        }
        this.getJobDetail(topOrderStartDate, topOrderEndDate);
      }
    },
    partnerCategoryFilter() {
      console.log(this.selectedWorkCategory);
      this.categoryFilterOption = [];
      var aesService = new AESService()
      partnerService
        .getPartnerCategories(this.selectedWorkCategory, aesService.EncodeUsingAES(this.partnerId))
        .then(resp => {
          this.categoryFilterOption.push;
          resp.response.forEach(data => {
            this.categoryFilterOption.push({
              name: data,
              value: data
            });
          });
          console.log(resp.response);
        })
        .catch(e => {});
    },
    getMultiSelectedDropdown(event) {
      this.selectedCategoryFilter = [];
      console.log(event);
      event.forEach(value => {
        this.selectedCategoryFilter.push(value.name);
        this.getJobDetail();
      });
      console.log(this.selectedCategoryFilter);
    },
    bindSelectedDropdown(value) {
      var selectedBussiness = [];
      if (this.categoryFilterOption.length > 0) {
        this.categoryFilterOption.forEach(data => {
          value.forEach(selected => {
            if (data.value == selected) {
              selectedBussiness.push({ name: selected, value: selected });
            }
          });
        });
      }
      console.log(selectedBussiness);
      return selectedBussiness;
    },
    getJobDetail(fromDate, toDate) {
      this.poTableDataList.items = [];
      this.poTableDataList.fields[3] = [];
      this.showTableLoding = true;
      var data = {
        category:
          this.selectedCategoryFilter.length > 0
            ? this.selectedCategoryFilter
            : null,
        jobType: this.selectedWorkCategory,
        partnerId: null,
        from: fromDate == null ? null : fromDate,
        to: toDate == null ? null : toDate
      };
      partnerService
        .getJobDetails(
          data,
          this.summaryPaginationPerPage,
          this.summaryCurrentPage - 1
        )
        .then(resp => {
          this.showTableLoding = false;
          this.poTableDataList.items = resp.response.content;
          this.poInvoiceCurrencyType = resp.response.content[0].rangeLabel;
          this.poTableDataList.fields[3].push({
            key: "cost",
            label: `Value (${resp.response.content[0].rangeLabel})`,
            thClass: "table-heading-text",
            tdClass: "text-right"
          });
          this.woPaginationTotalRow = resp.response.totalElements;
          console.log(this.showTableLoding);
          console.log(this.poTableDataList.items);
        })
        .catch(e => {
          this.showTableLoding = false;
          console.log(e.message);
        });
    },
    getSummaryCurrentPage() {
      if (this.summaryCurrentPage !== this.summaryPaginationCurrentPage) {
        this.summaryCurrentPage = this.summaryPaginationCurrentPage;
        this.getJobDetail();
      }
    },
    goToPoWoDetails(data) {
      this.loading = true;
      this.jobCurrency = data.currency;
      this.currentPOnumber = data.poNumber;
      this.getPoInvoiceSummary(data.poNumber);
      this.jobDetails = [];
      var aesService = new AESService()
      partnerService
        .getWorkCategoryDetails(this.selectedWorkCategory, aesService.EncodeUsingAES(data.poNumber))
        .then(resp => {
          this.loading = false;
          if (this.selectedCategory == "PO") {
            this.topOrderData.fields.push(
              {
                key: "materialCode",
                label: "Material Code",
                thClass: "thClassCenter",
                tdClass: "text-center"
              },
              {
                key: "materialDesc",
                label: "Material Description",
                thClass: "thClassLeft",
                tdClass: "text-left"
              },
              {
                key: "orderQuantity",
                label: "Ordered Quantity",
                thClass: "thClassRight",
                tdClass: "text-right"
              },
              {
                key: "deliveredQuantity",
                label: "Delivered Quantity",
                thClass: "thClassRight",
                tdClass: "text-right"
              },
              {
                key: "rate",
                label: "Rate",
                thClass: "thClassRight",
                tdClass: "text-right"
              },
              {
                key: "poHandleValue",
                label: "Total Value",
                thClass: "thClassRight",
                tdClass: "text-right"
              }
            );
          } else {
            this.topOrderData.fields.push(
              {
                key: "materialCode",
                label: "Material Code",
                thClass: "thClassCenter",
                tdClass: "text-center"
              },
              {
                key: "materialDesc",
                label: "Material Description",
                thClass: "thClassLeft",
                tdClass: "text-left"
              },
              {
                key: "orderQuantity",
                label: "Scope Quantity",
                thClass: "thClassRight",
                tdClass: "text-right"
              },
              {
                key: "deliveredQuantity",
                label: "Executed Quantity",
                thClass: "thClassRight",
                tdClass: "text-right"
              },
              {
                key: "rate",
                label: "Rate",
                thClass: "thClassRight",
                tdClass: "text-right"
              },
              {
                key: "poHandleValue",
                label: "Value",
                thClass: "thClassRight",
                tdClass: "text-right"
              }
            );
          }
          this.jobDetails = resp.response;
          this.category = resp.response.category;
          this.termsAndConditions = resp.response.termsAndConditions;
          this.topFunction();
          this.dialog = true;
        });
    },
    getPoInvoiceSummary(poNumber) {
      var aesService = new AESService()
      var poNumber = aesService.EncodeUsingAES(this.currentPOnumber);
      this.invoiceTable.items = [];      
      partnerService
        .getPoInvoiceDetails(
          this.selectedWorkCategory,
          poNumber,
          this.invoicePaginationPerPage,
          this.tempCurrentPage - 1
        )
        .then(resp => {
          if (resp.response) {
            this.invoiceSummary = resp.response;
            this.paginationTotalRow = resp.response.numberOfInvoice;
            if (this.selectedCategory == "PO") {
              this.invoiceTable.fields.push(
                {
                  key: "invoiceNumber",
                  label: "Invoice Number",
                  thClass: "thClassLeft",
                  tdClass: "text-left"
                },
                {
                  key: "invoiceValue",
                  label: "Invoice value",
                  thClass: "thClassRight",
                  tdClass: "text-right"
                },
                {
                  key: "invoiceDate",
                  label: "Invoice Date",
                  thClass: "thClassCenter",
                  tdClass: "text-center"
                },
                {
                  key: "status",
                  label: "Status",
                  thClass: "thClassCenter",
                  tdClass: "text-center"
                },
                {
                  key: "mrnNumber",
                  label: "MRN Number",
                  thClass: "thClassRight",
                  tdClass: "text-right"
                },
                {
                  key: "mrnDate",
                  label: "MRN Date",
                  thClass: "thClassCenter",
                  tdClass: "text-center"
                },
                {
                  key: "asnDate",
                  label: "ASN Date",
                  thClass: "thClassCenter",
                  tdClass: "text-center"
                },
                {
                  key: "ginDate",
                  label: "GIN Date",
                  thClass: "thClassCenter",
                  tdClass: "text-center"
                }
              );
              this.invoiceTable.items = resp.response.pages.content;
            } else {
              this.invoiceTable.fields.push(
                {
                  key: "invoiceNumber",
                  label: "Invoice Number",
                  thClass: "thClassLeft",
                  tdClass: "text-left"
                },
                {
                  key: "invoiceValue",
                  label: "Invoice value",
                  thClass: "thClassRight",
                  tdClass: "text-right"
                },
                {
                  key: "invoiceDate",
                  label: "Invoice Date",
                  thClass: "thClassCenter",
                  tdClass: "text-center"
                },
                {
                  key: "status",
                  label: "Status",
                  thClass: "thClassCenter",
                  tdClass: "text-center"
                },
                {
                  key: "mrnNumber",
                  label: "Bill Number",
                  thClass: "thClassRight",
                  tdClass: "text-right"
                },
                {
                  key: "mrnDate",
                  label: "Bill Date",
                  thClass: "thClassCenter",
                  tdClass: "text-center"
                },
                {
                  key: "asnDate",
                  label: "Measured Date",
                  thClass: "thClassCenter",
                  tdClass: "text-center"
                }
              );
              this.invoiceTable.items = resp.response.pages.content;
            }
          }

          // this.termsAndConditions = resp.response.termsAndConditions;
          // this.dialog = true;
        });
    },

    getCurrentPage() {
      if (this.tempCurrentPage !== this.invoicePaginationCurrentPage) {
        this.tempCurrentPage = this.invoicePaginationCurrentPage;
        this.getPoInvoiceSummary();
      }
    },
    clickedSearch() {
      this.partnerDetailsFilterText = this.partnerDetailsFilterText;
    },
    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    showParentOrderSummary() {
      this.isParent = true;
      this.partnerTypes = [];
      this.partnerTypes.push({
        value: null,
        text: "Select Period",
        disabled: true
      }),
        (this.poTableDataList.items = []);
      this.getpartnerDetails();
    }
  }
};
</script>
<style scoped>
.close-icon {
  cursor: pointer;
  -ms-transform: rotate(45deg); /* IE 9 */
  -webkit-transform: rotate(45deg); /* Safari 3-8 */
  transform: rotate(45deg);
}
.search-bar .input-group-prepend .input-group-text {
  height: 43px;
  border-radius: 0;
  font-family: "Source Sans Pro", sans-serif;
  border: 1px solid #ced4da;
  background: #f4f4f4;
  font-size: 15px;
  cursor: pointer;
}

.search-bar .form-control {
  height: 43px;
  border-radius: 0;
  border: 1px solid #ced4da;
  font-size: 18px;
  font-family: "Source Sans Pro", sans-serif;
}

.search-bar .form-control:focus {
  box-shadow: none;
}
.text-heading {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 24px;
  font-weight: 600;
}
.error-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 20px;
  color: #707070;
  font-weight: bold;
}
.terms-heading-value {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  color: #707070;
  font-weight: bold;
}
.po-toolbar {
  background-color: #6192b1;
  color: white;
  height: 50px !important;
}
.toolbar-heading {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  text-align: left;
  font-size: 22px;
}
.card-heading {
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  font-size: 18px;
  font-weight: 600;
  color: #1579ab;
}
.terms-text {
  margin-left: 2% !important;
  margin-top: 2px !important;
  text-align: justify;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
}
.terms-heading {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 600;
}
.pagination-invoice-table {
  float: right;
}
.back-div-text-style {
  cursor: pointer;
  width: fit-content;
}
.left-arrow-to-parent {
  transform: rotate(180deg);
  height: 15px;
  width: 15px;
}
.back-to-parent {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.55;
  letter-spacing: normal;
  text-align: left;
  color: #002d72;
}
</style>
<style >
.card-background {
  border-radius: 4px !important;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16) !important;
  background-color: #ffffff;
  -webkit-box-shadow: none !important;
}
/* .modal-widget {
  margin-left: 220px !important;
} */
.v-dialog--fullscreen > .v-card {
  max-height: 100% !important;
  min-width: 0% !important;
  margin: 0 !important;
  padding: 0 !important;
  margin-left: 15% !important;
  margin-top: 150px !important;
  overflow-x: hidden;
}
.thClass {
  background-color: #6192b1;
  color: white;
  text-align: center !important;
}
.thClassCenter {
  background-color: #6192b1;
  color: white;
  text-align: center !important;
}
.thClassLeft {
  background-color: #6192b1;
  color: white;
  text-align: left !important;
}
.thClassRight {
  background-color: #6192b1;
  color: white;
  text-align: right !important;
}
.thClassright {
  background-color: #6192b1;
  color: white;
  text-align: right !important;
}
.page-item.active .page-link {
  z-index: 1;
  color: #fff !important;
  background-color: #6192b1 !important;
  border-color: #6192b1 !important;
}
.page-link {
  color: black;
}
.page-link:focus {
  box-shadow: none !important;
}
.information-amount-text {
  float: right;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}
.filter-duration {
  width: 190px;
  height: 30px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 1px #00000014;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  font-family: "Source Sans Pro", sans-serif;
  opacity: 1;
}
.removefilter-icon {
  height: 20px !important;
  margin-bottom: 2px;
  float: right;
}
.removefilter-icon-drop {
  height: 20px !important;
  margin-top: -42px;
  float: right;
  position: relative;
  cursor: pointer;
}
.pagination-potable-table {
  position: absolute;
  right: 0;
}
</style>


